export interface LaborTypeSetupHistory {
  laborTypeID: string | null;
  laborTypeName: string | null;
  craft: string | null;
  class: string | null;
  bShiftDifferential: boolean | null;
  shiftDiffAmount: number | null;
  shiftDiffPercentage: number | null;
  dateModified: Date | null;
  modifiedBy: string | null;
}
